import PropTypes from "prop-types";

export default PropTypes.shape({
  engagements: PropTypes.number.isRequired,
  interviewCount: PropTypes.number.isRequired,
  interviewRate: PropTypes.number.isRequired,
  memberSince: PropTypes.string.isRequired,
  placements: PropTypes.number.isRequired,
  testimonial: PropTypes.string,
});
